import PropTypes from 'prop-types'
import { Grid } from '@mui/material'

import {
  SHIPPINGS_TABLE_HEADER_ORDER,
  SHIPPINGS_TABLE_HEAD_CELLS_NO_SORTABLE,
} from '../../../common/constants'
import useTranslations from '../../../i18n/useTranslations'
import Tabs from '../../../ui/components/tabs'

import { LAST_INCIDENTS_TAB_VALUE, LAST_SHIPPINGS_TAB_VALUE } from './constants'
import LatestIncidents from './LatestIncidents'
import LatestShipments from './LatestShipments'
import Actions from './Actions'

export const STEPS_DATA = {
  0: {
    title: 'tracking:pending',
    status: 'past',
  },
  1: {
    title: 'tracking:in-transit',
    status: 'past',
  },
  2: {
    title: 'tracking:available',
    status: 'past',
  },
  3: {
    title: 'tracking:distribution',
    status: 'error',
  },
  4: {
    title: 'tracking:delivered',
    status: 'disabled',
  },
}

const ShippingsSummary = ({
  shippingsFilterBtnsConfig,
  isLoadingShippings,
  isLoadingShippingsStates,
  shippings = [],
  selectedShippings = [],
  states,
  onTabChange = () => {},
  onShippingsStatusChange = () => {},
  onCheckboxChange = () => {},
  onSelectAllClick = () => {},
  onBackToListClick = () => {},
  getActionsForRow,
  actionsOptions,
  mainTabValue,
  onClickResolveIncident,
}) => {
  const t = useTranslations()
  const commonTableProps = {
    headCells: SHIPPINGS_TABLE_HEAD_CELLS_NO_SORTABLE,
    headCellsOrder: SHIPPINGS_TABLE_HEADER_ORDER,
    rows: shippings,
    states: states,
    stepsData: STEPS_DATA,
    isLoading: isLoadingShippings || isLoadingShippingsStates,
    //REVIEW: make noData dynamic
    noData: false,
    onClickResolveIncident,
  }

  const TABS = [
    {
      value: LAST_SHIPPINGS_TAB_VALUE,
      label: t('home:latest-shipments'),
      content: (
        <LatestShipments
          {...commonTableProps}
          shippingsFilterBtnsConfig={shippingsFilterBtnsConfig}
          onShippingsStatusChange={onShippingsStatusChange}
          onCheckboxChange={onCheckboxChange}
          onSelectAllClick={onSelectAllClick}
          selectedShippings={selectedShippings}
          onBackToListClick={onBackToListClick}
          getActionsForRow={getActionsForRow}
        />
      ),
    },
    {
      value: LAST_INCIDENTS_TAB_VALUE,
      label: t('home:latest-incidents'),
      content: <LatestIncidents {...commonTableProps} />,
    },
  ]

  return (
    <Grid item xs={12}>
      <Tabs tabs={TABS} value={mainTabValue} onTabChange={onTabChange} />
      <Actions actionsOptions={actionsOptions} />
    </Grid>
  )
}

ShippingsSummary.propTypes = {
  shippingsFilterBtnsConfig: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  mainTabValue: PropTypes.string,
  lastShippingsSelectedTabStatus: PropTypes.string,
  isLoadingShippings: PropTypes.bool,
  isLoadingShippingsStates: PropTypes.bool,
  shippings: PropTypes.array,
  states: PropTypes.array,
  selectedShippings: PropTypes.array,
  onTabChange: PropTypes.func,
  onShippingsStatusChange: PropTypes.func,
  onCheckboxChange: PropTypes.func,
  getActionsForRow: PropTypes.func,
  onSelectAllClick: PropTypes.func,
  onBackToListClick: PropTypes.func,
  actionsOptions: PropTypes.array,
  onClickResolveIncident: PropTypes.func,
}

export default ShippingsSummary
